const content = {
  home_screen_content: {
    en: {
      summary_no_video_html: `
            <h2>Before you start</h2> 
            <p>It's important you complete each step, or we won't be able to process your payment! Please read all steps before starting.</p>`,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `
                    <p>Go to your phone <b>Home Screen</b> and swipe all the way to the first (left-most) screen.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: `
                        <p>Start <img style="height:20px;margin-right:2px;margin-left:2px;" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/record@3x.png" /> screen
                        recording.<br/><i>If you don’t know how to screen record, click on the link above.</i></p>`
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: `
                    <p>Swipe through each screen of icons and widgets until you reach the final (right-most) screen.<br/>
                    <i>You <span style="color:red">do NOT</span> need to open any folders or any apps or share any in-app data.</i></p>`
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `
                        <p>Stop the screen recording and upload your video file.</p>`
        }
      ],
    },
  },
  ios_storage: {
    en: {
      summary_no_video_html: `
            <div style="margin-top:1.0rem;"><b>Before your start</b></div>
            <p>It's important you complete each step, or we won't be able to process your payment! Please read all 7 steps before starting.</p>  
          `,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `
                  <p>
                      Start <img style="height:20px;margin-right:2px;margin-left:2px;" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/record@3x.png" /> screen recording. (If you don’t know how to screen record, click on link above)
                  </p>
                `
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: `<p>Open Settings <img style="height:20px;margin-right:2px;margin-left:2px;" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/ios-storage/icon@3x.png" /></p>`
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: `<p>Tap <b>General</b></p>`
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>Then tap <b>About</b></p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Scroll to the bottom of the page</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Stop the screen recording</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Upload your video file</p>`
        },
      ],
    },
  },
  ios_app_privacy_export: {
    en: {
      summary_no_video_html: ` 
          <p>You completed part one of this Retro task a few days ago, which asked you to turn on your iOS App Privacy Report
          from Apple. This is part two — downloading and uploading your App Privacy Report data. Here are the steps:</p>`,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Open the <b>Settings</b> app on your phone.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: `<p>Scroll to and tap on <b>Privacy & Security</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: `<p>Scroll to and tap on the <b>App Privacy Report</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>At the top right of the screen, tap on the <b>share icon</b> (square with arrow).</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Select <b>Save to Files</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Select the folder to save the file to (for example Documents).</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Return to this page, tap on Choose file, and select the App_Privacy_report.json (file
              name may be different).</p>`
        }
      ],
    }
  },
  ios_apple_intelligence_export: {
    en: {
      summary_no_video_html: ` 
          <p>You completed part one of this Retro task, which asked you to turn on your Apple Intelligence Report. 
          This is part two — downloading and uploading your report data. Here are the steps:</p>`,

      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Open the <b>Settings</b> app on your phone.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: `<p>Scroll to and tap on <b>Privacy & Security</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: `<p>Scroll to and tap on the <b>Apple Intelligence Report</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>Tap on <b>Report Duration</b> and select <b>7 days</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Tap on <b>Export Activity</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Select <b>Save to Files</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Select the folder to save the file to (for example Documents).</p>`
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: `<p>Return to this page, tap on <b>Choose file</b>, and select the Apple_Intelligence_Report.json (file
              name may be different).</p>`
        }
      ],
    }
  },
  ios_battery_usage_history: {
    en: {
      summary_html: '',
      summary_no_video_html: `
              <p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to
                hit record and scroll through your battery usage.</p>
            <div class="text-with-icon">
              <div class="icon">⚠️</div>
              <div class="text">
                We’ll only pay MSR rewards for videos that fully match the steps below.
              </div>
            </div>`,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Open <b>Settings</b> and tap <b>Battery</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: `<p>Start the screen recording.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: `<p>SCROLL ONE — Tap on <b>Last 10 Days</b> and scroll to the bottom so that you
                  capture the % battery used by each app.</p>`
        },
        {
          step_type: 'centered_image',
          image_width: '70%',
          image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/battery-usage/battery-screenshot-1.png'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: '<p>Scroll back up and tap <b>SHOW ACTIVITY</b> (just below the charts).</p>'
        },
        {
          step_type: 'centered_image',
          image_width: '70%',
          image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/battery-usage/battery-screenshot-2.png'
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: '<p>SCROLL TWO — Scroll to the bottom so that you capture the time spent by each app.</p>'
        },
        {
          step_type: 'centered_image',
          image_width: '70%',
          image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/battery-usage/battery-screenshot-3.png'
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: '<p>Stop screen recording. Remember — we need both the % and time spent for this job.</p>'
        }
      ],
    }
  },
  screen_time_stats: {
    en: {
      summary_html: `<p>This Screen Time Retro video task has several steps. Please follow the instructions carefully.
            It's a bit of extra work, but it should be easy once you get the hang of it. Remember: four weeks of screen
            time is needed but only three out of the four weeks will be collected by us.</p>`,
      after_video_html: `<p>It's a bit of extra work, but it should be easy once you get the hang of it. Remember:
          four weeks of screen time is needed. 👇</p>`,
      video_thumbnail: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_Thumbnail.gif',
      video_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_English.mp4',
      video_poster: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_English_Poster.jpg',
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Open your phone's <b>Settings</b> and tap on <b>Screen Time</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>Under the screen time chart tap on <b>See All Activity</b>.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>At the top of the See All Activity screen, make sure <b>Week</b> is selected.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>If you have more than one iOS device, tap <b>Devices</b> in the top-right corner and select
              the iPhone you are currently using.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Start the <b>screen recording</b>. (If you don't know how to screen record, tap
              <a href="/retro/help/screen-recording/ios">here to watch the tutorial</a>.)</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Scroll down through the page — each time you see the words <b>Show More</b>, tap on it
              until the full list is visible and you reach the very bottom of the page.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Once at the bottom of the page, tap on the <b>left arrow</b> to see <b>last week</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: `<p>Scroll to the top.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: `<p>Scroll down just a little until you see the date bar across the top of the screen.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '10',
          description_html: `<p>Tap the <b>left arrow</b> again and scroll to the <b>bottom</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '11',
          description_html: `<p>One last time, tap the <b>left arrow</b> again and scroll to the <b>top</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '12',
          description_html: `<p>Stop the recording and upload when you have recorded <b>four weeks of screen time.</b>.</p>`
        }
      ],
      video_show_web_client: true,
    },
    pt: {
      summary_html: `<p>Para aceder ao seu "Tempo de Uso", por favor siga as intruções em baixo:</p>`,
      video_thumbnail: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_Thumbnail_Portuguese.png',
      video_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_Portuguese.mp4',
      video_poster: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_Portuguese_Poster.jpg',
      after_video_html: '<p>Como alguns ficheiros são grandes, sugerimos que esteja conectado ao Wi-Fi para tornar o processo de upload o mais rápido possível.</p>',
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Abra as configurações do seu celular clicando no ícone de "Ajustes".</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>Clique no ícone de "Tempo de Uso", seguido de "Ver Todas as Actividades em Apps e Sites".</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>Verifique que no topo do ecrā estâ selecionada a opção "Semana".</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>Se você tiver mais de um dispositivo iOS, toque em Dispositivos no canto superior direito e selecione o iPhone que você está usando no momento.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Inicie a gravação do seu ecrã.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Começe a fazer scroll lentamente até que lhe apareça "Esta semana" no topo do ecrā e faça clique na seta para a esquerda para mudar para "Semana Passada".</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Faça scroll e clique em "Mostrar mais" sempre que lhe aparecer essa hipótese.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: `<p>Quando chegar ao fim das "Notificações", clique na seta para a esquerda no topo do ecrā para ir mais uma semana para trás.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: `<p>Faça scroll até acima outra vez - quando chegar ao topo do ecrā (onde poderá ver os gráficos com os dias), volte a fazer scroll lentamente até aparecer a barra da semana.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '10',
          description_html: `<p>Clique pela última vez na seta da esquerda para chegar a 3 semana atrás, e faça scroll até ao fim da página.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '11',
          description_html: `<p>Termine a gravação do ecrã.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '12',
          description_html: `<p>Escolhar "Terminei estes passos" - e clique no botão rouxo para subir o vídeo que acabou de gravar.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '13',
          description_html: `<p>Se lhe aparecer a mensagem relacionado com accesso ao seu album de fotografias do celular, clique em "Permitir Acesso total" - isto permitirá lhe encontrar o vídeo que acabou de gravar.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '14',
          description_html: `<p>Selecione o vídeo que criou do archivo de fotografias do seu celular - e confirma o upload.</p>`
        },
      ],
      video_show_web_client: true,
    },
    es: {
      summary_html: `<p>Para acceder a tu "Tiempo de Uso", por favor sigue las instrucciones a continuación:</p>`,
      video_thumbnail: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_Thumbnail_Spanish.png',
      video_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_Spanish.mp4',
      video_poster: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_Spanish_Poster.jpg',
      after_video_html: '<p>Dado que algunos archivos son grandes, te sugerimos que te conectes a una red Wi-Fi para que el proceso de carga sea lo más rápido posible.</p>',
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Abre la configuración de tu celular haciendo clic en el ícono de "Ajustes".</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>Haz clic en el ícono de "Tiempo de Uso", seguido de "Ver Todas las Actividades en Apps y Sitios".</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>Verifica que en la parte superior de la pantalla esté seleccionada la opción "Semana".</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>Si tienes más de un dispositivo iOS, toca en Dispositivos en la esquina superior derecha y selecciona el iPhone que estás usando en ese momento.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Inicia la grabación de tu pantalla.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Comienza a desplazarte lentamente hasta que aparezca "Esta semana" en la parte superior de la pantalla y haz clic en la flecha hacia la izquierda para cambiar a "Semana Pasada".</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Desplázate y haz clic en "Mostrar más" cada vez que aparezca esa opción.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: `<p>Cuando llegues al final de las "Notificaciones", haz clic en la flecha hacia la izquierda en la parte superior de la pantalla para retroceder otra semana.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: `<p>Desplázate hacia arriba nuevamente, cuando llegues a la parte superior de la pantalla (donde puedes ver los gráficos con los días), vuelve a desplazarte lentamente hasta que aparezca la barra de la semana.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '10',
          description_html: `<p>Haz clic por última vez en la flecha izquierda para retroceder 3 semanas atrás y desplázate hasta el final de la página.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '11',
          description_html: `<p>Finaliza la grabación de la pantalla.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '12',
          description_html: `<p>Selecciona "He terminado estos pasos" y haz clic en el botón morado para cargar el video que acabas de grabar.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '13',
          description_html: `<p>Si aparece un mensaje relacionado con el acceso a tu álbum de fotografías del celular, haz clic en "Permitir acceso total", esto te permitirá encontrar el video que acabas de grabar.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '14',
          description_html: `<p>Selecciona el video que creaste desde el archivo de fotografías de tu celular y confirma la carga.</p>`
        },
      ],
      video_show_web_client: true,
    },
  },
  screen_time_stats_1_day: {
    en: {
      summary_html: `<p>This Screen Time Retro video task has several steps. Please follow the instructions carefully.
            It's a bit of extra work, but it should be easy once you get the hang of it.</p>`,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Open your phone's <b>Settings</b> and tap on <b>Screen Time</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>Under the screen time chart tap on <b>See All Activity</b>.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>At the top of the See All Activity screen, make sure <b>Day</b> is selected.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>If you have more than one iOS device, tap <b>Devices</b> in the top-right corner and select
              the iPhone you are currently using.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Tap on the left blue arrow to go back to Yesterday.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Start the <b>screen recording</b>. (If you don't know how to screen record, tap
                    <a href="/retro/help/screen-recording/ios">here to watch the tutorial</a>.)</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Scroll down through the page and find the following apps (if you have used them): <b>Netflix,
                        YouTube, TikTok, Instagram, Amazon Prime Video, Hulu, Apple TV+, Disney+.</b></p>`
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: `<p>Each time you find one of the apps, tap on them to get more information about your
                        screen time usage. For example:</p>`
        },
        {
          step_type: 'centered_image',
          image_width: '200px',
          image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/screen_time_app_data.gif'
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: `<p>Continue to scroll and each time you see the words Show More, tap on it until the full
                        list is visible and you reach the very bottom of the page.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '10',
          description_html: `<p>Now, we want to find category usage for <b>Games</b>. Scroll back to the top of the list and
                        tap on <b>SHOW CATEGORIES</b>. (It's a blue link on the right-side of the screen just underneath the usage graph.</p>`
        },
        {
          step_type: 'centered_image',
          image_width: '200px',
          image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/screen_time_show_categories.jpeg'
        },
        {
          step_type: 'numbered_step',
          number: '11',
          description_html: `<p>If the <b>Games</b> category is listed, tap on that.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '12',
          description_html: `<p>You're all done! Stop recording and upload your video.</p>`
        },
      ],
      video_show_web_client: true,
    },
  },
  screen_time_stats_7_day: {
    en: {
      summary_html: `<p>This Screen Time Retro video task has several steps. Please follow the instructions carefully.
            It's a bit of extra work, but it should be easy once you get the hang of it.</p>`,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Open your phone's <b>Settings</b> and tap on <b>Screen Time</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>Under the screen time chart tap on <b>See All Activity</b>.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>At the top of the See All Activity screen, make sure <b>Day</b> is selected.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>If you have more than one iOS device, tap <b>Devices</b> in the top-right corner and select
              the iPhone you are currently using.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Tap on the left blue arrow to go back to Yesterday.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Start the <b>screen recording</b>. (If you don't know how to screen record, tap
              <a href="/retro/help/screen-recording/ios">here to watch the tutorial</a>.)</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Scroll down through the page and each time you see the words Show More, tap on it until the full
                        list is visible and you reach the very bottom of the page.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: `<p>Once you're at the bottom of the page, tap on the left arrow to see the previous day.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: `<p>Scroll to the top.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '10',
          description_html: `<p>Scroll down just a little until you see the date bar across the top of the screen.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '11',
          description_html: `<p>Tap the left arrow again and scroll to the bottom.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '12',
          description_html: `<p>Repeat <b>steps 9 - 11</b> for an additional <b>thirteen more times</b> to provide screen time activity for the last <b>fourteen days</b> in total.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '13',
          description_html: `<p>Once at the bottom of the page, stop the recording and upload your recording.</p>`
        },
      ],
      video_show_web_client: true,
    },
  },
  screen_time_stats_21_day: {
    en: {
      summary_html: `<p>This Screen Time Retro video task has several steps. Please follow the instructions carefully.
            It's a bit of extra work, but it should be easy once you get the hang of it.</p>`,
      video_url: 'https://d3s00xghdjywqy.cloudfront.net/Video%20Tutorials/How%20to%20complete%20Daily%20Screen%20Time%20Retro%20-%2024%20days.mp4',
      video_poster: 'https://d3s00xghdjywqy.cloudfront.net/Video%20Tutorials/24_daily_screen_time_thumbnail.jpg',
      video_thumbnail: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/How_To_Screen_Time_Thumbnail.gif',
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Open your phone's <b>Settings</b> and tap on <b>Screen Time</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>Under the screen time chart tap on <b>See All Activity</b>.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>At the top of the See All Activity screen, make sure <b>Day</b> is selected.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>If you have more than one iOS device, tap <b>Devices</b> in the top-right corner and select
              the iPhone you are currently using.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>Tap on the left blue arrow to go back to Yesterday.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Start the <b>screen recording</b>. (If you don't know how to screen record, tap
              <a href="/retro/help/screen-recording/ios">here to watch the tutorial</a>.)</p>`
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: `<p>Scroll down through the page. Each time you see the words Show More, tap on it until the full
                        list is visible and you reach the very bottom of the page.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: `<p>We need to <b>repeat those steps for 24 more days</b>. To do that, tap on the left arrow at the top of the screen to go back a day.</i>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: `<p>Once you have the 24th day completed, stop the recording and upload your video.</p>`
        },
      ],
      video_show_web_client: true,
    },
  },

  safari_web_browsing_history: {
    en: {
      summary_html: `<p>Read the steps below, and then you're ready to hit record and scroll through your web browsing history in Safari.</p>`,
      video_thumbnail: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_Thumbnail_English.png',
      video_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_English.mp4',
      video_poster: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_English_Poster.jpg',
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: '<p>Open the <b>Safari</b> app on your phone.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>In the app, tap on the <b>bookmark icon</b> at the bottom of the screen.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>Tap on the <b>clock icon</b> (in the top-right) to see your history.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: '<p>Start the screen recording.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: '<p>If on iOS 17 - For each date, expand the list by tapping on the right arrow next to the date. Repeat for all dates.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: '<p>Scroll to the end of the list.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: '<p>Stop screen recording..</p>'
        }
      ],
      video_show_web_client: true,
    },
    es: {
      summary_html: `<p>Para acceder a tus datos de Safari, sigue estas instrucciones:</p>`,
      video_thumbnail: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_Thumbnail_Spanish.png',
      video_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_Spanish.mp4',
      video_poster: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_Spanish_Poster.jpg',
      after_video_html: `<p>Dado que algunos archivos son grandes, te sugerimos estar conectado a Wi-Fi para hacer el proceso de subida lo más rápido posible.</p>`,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: '<p>Abre la aplicación Safari en tu celular.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>En la parte inferior de la pantalla, haz clic en el ícono del libro.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>En el menú que aparece, haz clic en el reloj en el lado derecho para acceder a tu historial.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: '<p>Inicia la grabación de tu pantalla.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: '<p>Si tu sistema operativo de Apple es iOS 17 o superior, deberás hacer clic en la flecha hacia la derecha junto a cada fecha; repite este paso para todas las fechas disponibles.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: '<p>Desplázate hasta el final de la página a tu propia velocidad.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: '<p>Finaliza la grabación de tu pantalla.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: '<p>Selecciona "He completado estos pasos" y haz clic en el botón morado para subir el vídeo que acabas de grabar.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: '<p>Si aparece un mensaje relacionado con el acceso a tu álbum de fotos del celular, haz clic en "Permitir acceso total"; esto te permitirá encontrar el vídeo que acabas de grabar.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '10',
          description_html: '<p>Selecciona el vídeo que creaste del archivo de fotos de tu celular y confirma la subida.</p>'
        }
      ],
      video_show_web_client: true,
    },
    pt: {
      summary_html: `<p>Para aceder aos seus dados de Safari, por favor siga as intruções em baixo:</p>`,
      video_thumbnail: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_Thumbnail_Portuguese.png',
      video_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_Portuguese.mp4',
      video_poster: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/How_To_Safari_Portuguese_Poster.jpg',
      after_video_html: `<p>Como alguns ficheiros são grandes, sugerimos que esteja conectado ao Wi-Fi para tornar o processo de upload o mais rápido possível.</p>`,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: '<p>Abra o aplicativo Safari no seu celular.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: '<p>Na parte inferior do ecrã, faça clique no ícone do livro.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: '<p>No menu que lhe vai aparecer, clique no relógio do lado direito , para aceder ao seu histórico.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: '<p>Inicie a gravação do ecrã.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: '<p>Se o seu sistema operativo da Apple for o iOS 17 ou acima, terá de clicar na seta à direita de cada data - por favor repita para as todas as datas disponíveis.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: '<p>Faça scroll até ao fim da página, á velocidade que quiser.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '7',
          description_html: '<p>Termine a gravação do ecrã.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '8',
          description_html: '<p>Escolhar "Terminei estes passos" - e clique no botão rouxo para subir o vídeo que acabou de gravar.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: '<p>Se lhe aparecer a mensagem relacionado com accesso ao seu album de fotografias do celular, clique em "Permitir Acesso total" - isto permitirá lhe encontrar o vídeo que acabou de gravar.</p>'
        },
        {
          step_type: 'numbered_step',
          number: '9',
          description_html: '<p>Selecione o vídeo que criou do archivo de fotografias do seu celular - e confirma o upload.</p>'
        }
      ],
      video_show_web_client: true,
    }
  },
  safari_data_export: {
    en: {
      summary_no_video_html: `
                <p>This is a task to export and upload your Safari web browsing history.</p>
                <p>Note that <b>this is only supported on iOS 18.2</b>, which is the latest release of iOS. If you haven't upgraded yet, you
                can do so through the Settings app on your phone before completing this task. If you haven't upgraded, the Export option will
                not be available to you.</p>
                <p>When you're ready, complete the following steps:</p>`,
      steps: [
        {
          step_type: 'numbered_step',
          number: '1',
          description_html: `<p>Open the <b>Settings</b> app on your phone.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '2',
          description_html: `<p>Scroll to the bottom and tap on <b>Apps</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '3',
          description_html: `<p>Scroll down and tap on <b>Safari</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '4',
          description_html: `<p>Scroll down a little and you'll see a blue link for <b>Export</b>, tap on that.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '5',
          description_html: `<p>This is the Export screen. Unselect Credit Cards and Passwords (we don't need them) and then tap on <b>Save to Downloads</b>.</p>`
        },
        {
          step_type: 'numbered_step',
          number: '6',
          description_html: `<p>Now on this screen, tap on <b>Choose file</b> and select the "Safari Export" zip file inside your Downloads folder.</p>`
        }
      ],
    }
  }
};

export const appleDataTypes = {
  home_screen_content: {
    data_type: 'home_screen_content',
    data_type_description: 'Home Screen Content',
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/home-screen-content/logo.png',
    capture_type: 'video',
    ios: {
      use_in_app_screen_recorder: false,
      ...content.home_screen_content,
    },
  },
  ios_storage: {
    data_type: 'ios_storage',
    data_type_description: 'iOS Storage',
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/home-screen-content/logo.png',
    //This logo doesn't work logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/battery-usage/logo.jpg',
    capture_type: 'video',
    ios: {
      use_in_app_screen_recorder: false,
      ...content.ios_storage
    }

  },
  ios_app_privacy_export: {
    data_type: 'ios_app_privacy_export',
    data_type_description: 'App Privacy Report',
    require_consent: true,
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/ios_app_privacy_export/app-privacy.png',
    capture_type: 'file',
    use_in_app_screen_recorder: false,
    generic: {
      ...content.ios_app_privacy_export,
    }
  },
  ios_apple_intelligence_export: {
    data_type: 'ios_apple_intelligence_export',
    data_type_description: 'Apple Intelligence Report',
    require_consent: true,
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/apple_intelligence_logo.png',
    capture_type: 'file',
    use_in_app_screen_recorder: false,
    generic: {
      ...content.ios_apple_intelligence_export,
    }
  },
  'ios_battery_usage_history': {
    data_type: 'ios_battery_usage_history',
    data_type_description: 'Battery Usage History',
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/home-screen-content/logo.png',
    //logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/battery-usage/logo.jpg',
    capture_type: 'video',
    use_in_app_screen_recorder: false,
    ios: {
      ...content.ios_battery_usage_history,
    }
  },
  'screen_time_stats': {
    data_type: 'screen_time_stats',
    data_type_description: 'Screen Time Stats',
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/logo.jpg',
    capture_type: 'video',
    use_in_app_screen_recorder: false,
    ios: {
      ...content.screen_time_stats,
    },
  },
  'screen_time_stats_1_day': {
    data_type: 'screen_time_stats_1_day',
    data_type_description: 'Screen Time Stats 1 Day',
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/logo.jpg',
    capture_type: 'video',
    use_in_app_screen_recorder: false,
    ios: {
      ...content.screen_time_stats_1_day,
    },
  },
  'screen_time_stats_7_day': {
    data_type: 'screen_time_stats_7_day',
    data_type_description: 'Screen Time Stats 7 Day',
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/logo.jpg',
    capture_type: 'video',
    use_in_app_screen_recorder: false,
    ios: {
      ...content.screen_time_stats_7_day,
    },
  },
  'screen_time_stats_21_day': {
    data_type: 'screen_time_stats_21_day',
    data_type_description: 'Screen Time Stats 21 Day',
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/screen-time-stats/logo.jpg',
    capture_type: 'video',
    use_in_app_screen_recorder: false,
    ios: {
      ...content.screen_time_stats_21_day,
    },
  },
  'safari_web_browsing_history': {
    data_type: 'safari_web_browsing_history',
    data_type_description: 'Safari Web Browsing History',
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/logo.png',
    capture_type: 'video',
    use_in_app_screen_recorder: false,
    ios: {
      ...content.safari_web_browsing_history
    }
  },
  safari_data_export: {
    data_type: 'safari_data_export',
    data_type_description: 'Safari Data Export',
    require_consent: true,
    logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/safari-web-browsing-history/logo.png',
    capture_type: 'file',
    use_in_app_screen_recorder: false,
    generic: {
      ...content.safari_data_export,
    }
  },
}